const attributePatterns = [
  {
    name: 'serial_sku',
    regex: /^([0-9a-zA-Z]{11})([0-9a-zA-Z]{6})$/,
    fields: ['serial_number', 'sku'],
  },
]

export default attributePatterns
